module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/124-vatican-city-cb610731487d6dd5055a0a92c72c85cd.svg";